import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useSWR from 'swr/immutable';
import { useCookies } from 'react-cookie';
import { useFormik } from 'formik';

import { createLicenseKey } from '../../../api/bots';
import { COOKIE } from '../../../constants';
import OperatingSystemTag from '../../bots/common/OperatingSystemTag';
import { TidalButton } from '../../common/button';
import TidalDropdown from '../../common/dropdown/TidalDropdown';
import TidalDateField from '../../common/input/TidalDateInput';
import TidalInputField from '../../common/input/TidalInputField';
import TidalSuffixInputField from '../../common/input/TidalSuffixInputField';
import TidalTextBox from '../../common/input/TidalTextBox';
import { TidalTag } from '../../common/tag';
import { Box } from '../../Flex';
import TidalDashboardAddBotKeySearchInput from './TidalDashboardAddBotKeySearchInput';
import { toast } from 'react-toastify';
import Loading from '../../Loading';
import Image from 'next/image';
import imageUrl from '../../../lib/image-url';

const TidalDashboardAddBotKeyModalWrapper = styled.div`
  width: 833px;
  max-width: 100%;
  background-color: ${(props) => props.theme.colors.background};
  border-radius: 14px;
  padding: 23px 27px;
  max-height: 827px;
  overflow: hidden;
  @media only screen and (max-width: 676px) {
    padding: 16px;
  }
`;

const TidalDashboardAddBotKeyModalTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
`;

const TidalDashboardAddBotKeyModalTitle = styled.p`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: ${(props) => props.theme.colors.text[1]};
`;

const TidalDashboardAddBotKeyRequired = styled.div`
  position: relative;

  & > p {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: ${(props) => props.theme.colors.text[0]};
  }
  & > span {
    position: absolute;
    left: -10px;
    bottom: -4px;
    color: ${(props) => props.theme.colors.text[3]};
  }
`;

const TidalDashboardAddBotKeyBodyRow = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr;
  grid-gap: 0 28px;
  margin-top: 24px;
  & > div:nth-child(1) {
    border-right: 1px solid ${(props) => props.theme.colors.borderColors[0]};
  }
  @media only screen and (max-width: 676px) {
    grid-template-columns: 80px 1fr;
    & > div:nth-child(2) {
      overflow-y: auto;
      overflow-x: hidden;
      max-height: 700px;
      padding-right: 8px;
    }
  }
`;

const TidalDashboardAddBotKeyModalSubTitle = styled.p`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.colors.text[1]};
  margin-bottom: 2px;
  position: relative;
  & > span {
    font-size: 14px;
    line-height: 17px;
    position: absolute;
    right: 0px;
    bottom: 0px;
    color: ${(props) => props.theme.colors.accent};
  }
`;

const TidalDashboardAddBoyKeyForm = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0 16px;
  padding-top: 19px;
  margin-top: 12px;
  border-top: 1px solid ${(props) => props.theme.colors.borderColors[0]};
  @media only screen and (max-width: 676px) {
    display: block;
    & > div:nth-child(2) {
      margin-top: 16px;
    }
  }
`;

const TidalDashboardAddBotKeyTagsRow = styled.div`
  display: flex;
  grid-gap: 10px;
  flex-wrap: wrap;
`;

const TidalDashboardAddBotKeyBotWrapper = styled.div<{
  isSelected: boolean;
}>`
  height: 77px;
  cursor: pointer;
  width: 77px;
  border-radius: 10px;
  outline: ${(props) =>
    props.isSelected ? `2px solid ${props.theme.colors.accent}` : ''};
  border: ${(props) =>
    props.isSelected ? `3px solid ${props.theme.colors.borderColors[2]}` : ''};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  margin-bottom: 8px;
  @media only screen and (max-width: 676px) {
    height: 50px;
    width: 50px;
  }
  & > span > img {
    height: 63px;
    width: 63px;
    border-radius: 10px;
    background-color: black;
    @media only screen and (max-width: 676px) {
      height: 40px;
      width: 40px;
    }
  }
`;

const TidalDashboardAddNewBotList = styled.div`
  overflow-y: auto;
  max-height: 660px;
  padding-top: 2px;
`;

const TidalDashboardAddNewBotKeyModalFooter = styled.div`
  margin-top: 24px;
  padding-top: 26px;
  border-top: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  display: grid;
  grid-template-columns: 125px 214px;
  justify-content: flex-end;
  grid-gap: 16px;
  @media only screen and (max-width: 676px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }
`;

const TidalDashboardAddNewBotKeySelectedBot = styled.div`
  display: grid;
  grid-template-columns: 114px 1fr;
  grid-gap: 19px;
  margin-top: 28px;
  @media only screen and (max-width: 676px) {
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr;
  }
  & > div > .bot-name {
    display: flex;
    margin-bottom: 17px;
    grid-gap: 7px;
    flex-wrap: wrap;
    & > p {
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      color: ${(props) => props.theme.colors.text[2]};
    }
  }
  & > img {
    height: 114px;
    width: 114px;
    border-radius: 10px;
    background-color: black;
  }
`;

interface ITidalDashboardAddBotKeyModal {
  onClose: () => void;
  onAdded: () => void;
}

interface MyFormValues {
  licenseKey: string;
  purchasePrice: string;
  renewalDate: any;
}

const TidalDashboardAddBotKeyModal = ({
  onClose,
  onAdded,
}: ITidalDashboardAddBotKeyModal): JSX.Element => {
  const {
    data,
    error: err,
    isValidating,
    mutate,
  } = useSWR('/dashboard/licenses/software');

  const [licenseKey, setLicenseKey] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [purchasePrice, setPurchasePrice] = useState('');
  const [renewalDate, setRenewalDate] = useState(dayjs());
  const [renewalPrice, setRenewalPrice] = useState('');
  const [renewalInterval, setRenewalInterval] = useState('');
  const [notes, setNotes] = useState('');
  const [notesArray, setNotesArray] = useState('');
  const [licenseType, setLicenseType] = useState('');
  const [selectedTag, setSelectedTag] = useState(-1);
  const [softwareId, setSoftwareId] = useState('');

  const [tags, setTags] = useState([
    {
      title: 'Holding',
      type: 'success',
      isSelected: false,
      value: 1,
    },
    {
      title: 'Using',
      type: 'primary',
      isSelected: false,
      value: 2,
    },
    {
      title: 'Renting',
      type: 'warning',
      isSelected: false,
      value: 3,
    },
    {
      title: 'Selling',
      type: 'info',
      isSelected: false,
      value: 4,
    },
    {
      title: 'Sold',
      type: 'error',
      isSelected: false,
      value: 5,
    },
  ]);

  const [bots, setBots] = useState(data);
  const [selectedBot, setSelectedBot] = useState({
    id: '',
    image_url: '',
    name: '',
    license_types: [],
    operating_system: '',
  });

  useEffect(() => {
    if (data) {
      const temp = data;
      temp.sort((a, b) => (a.name > b.name ? 1 : -1));

      setBots(temp);
      setSelectedBot(temp[0]);
    }
  }, [data]);

  const handleTagSelection = (tag) => {
    const tempTags = [...tags];
    for (let i = 0; i < tempTags.length; i++) {
      if (tempTags[i].value == tag.value) {
        tempTags[i].isSelected = true;
        setSelectedTag(tempTags[i].value);
      } else {
        tempTags[i].isSelected = false;
      }
    }

    setTags(tempTags);
  };

  const handleCreateLicenseKey = async () => {
    // if (
    //   licenseKey.length == 0 ||
    //   licenseType.length == 0 ||
    //   purchasePrice.length == 0
    // ) {
    //   toast('Please fill all the mandatory fields', { type: 'error' });
    //   return;
    // }
    // if (licenseType != "Lifetime") {
    //   if (renewalPrice.length == 0 || renewalInterval.length == 0) {
    //     toast("Please fill all the mandatory fields", { type: "error" });
    //     return;
    //   }
    // }
    setIsCreating(true);
    try {
      await createLicenseKey({
        licenseKey,
        licenseType: licenseType.toLowerCase().includes('lifetime')
          ? 'lifetime'
          : 'renewal',
        softwareId: selectedBot.id,
        name: '',
        renewalDate,
        renewalInterval: parseInt(renewalInterval) || 0,
        renewalPrice: parseInt(renewalPrice) || 0,
        purchasePrice: parseInt(purchasePrice),
        notes: [...notes.split('\n')],
        tags: [selectedTag],
      });
      onAdded();
    } catch (e) {}
    setIsCreating(false);
  };

  const validate = (values: MyFormValues) => {
    const errors: MyFormValues = {
      licenseKey: '',
      purchasePrice: '',
      renewalDate: '',
    };
    if (!values.licenseKey) {
      errors.licenseKey = 'Required';
    }
    if (!values.purchasePrice) {
      errors.purchasePrice = 'Required';
    }
    return errors;
  };

  const formik = useFormik({
    initialValues: {
      licenseKey,
      purchasePrice,
      renewalDate,
    },
    validate,
    onSubmit: (values) => {},
  });

  if (isValidating) return <Loading />;

  return (
    <TidalDashboardAddBotKeyModalWrapper>
      <TidalDashboardAddBotKeyModalTitleRow>
        <TidalDashboardAddBotKeyModalTitle>
          Add Bot Key
        </TidalDashboardAddBotKeyModalTitle>
        <TidalDashboardAddBotKeyRequired>
          <p>Required Field</p>
          <span>*</span>
        </TidalDashboardAddBotKeyRequired>
      </TidalDashboardAddBotKeyModalTitleRow>
      <TidalDashboardAddBotKeyBodyRow>
        <div>
          <TidalDashboardAddBotKeyModalSubTitle>
            Select Bot
          </TidalDashboardAddBotKeyModalSubTitle>
          <Box height={8} />
          <TidalDashboardAddNewBotList>
            {bots?.map((bot, key) => (
              <div key={key}>
                <TidalDashboardAddBotKeyBotWrapper
                  onClick={() => {
                    setSelectedBot(bot);
                    setLicenseType(bot.license_types[0]);
                  }}
                  isSelected={bot.id == selectedBot.id}
                >
                  <Image
                    src={imageUrl(`bots/${bot?.image_url}`)}
                    alt={`${bot.name} logo`}
                    width={77}
                    height={77}
                  />
                </TidalDashboardAddBotKeyBotWrapper>
              </div>
            ))}
          </TidalDashboardAddNewBotList>
        </div>
        {bots && (
          <div>
            <TidalDashboardAddBotKeyModalSubTitle>
              Search Bot
            </TidalDashboardAddBotKeyModalSubTitle>
            <Box height={17} />
            <TidalDashboardAddBotKeySearchInput
              label=""
              items={bots}
              onSelect={(bot) => {
                setSelectedBot(bot);
                setLicenseType(bot.license_types[0]);
              }}
            />
            <TidalDashboardAddNewBotKeySelectedBot>
              <Image
                src={imageUrl(`bots/${selectedBot?.image_url}`)}
                alt={`${selectedBot?.name} logo`}
                width={114}
                height={114}
              />
              <div>
                <div className="bot-name">
                  <p>{selectedBot.name}</p>
                  {selectedBot.operating_system?.split(',').map((os, key) => {
                    return (
                      <div key={key}>
                        <OperatingSystemTag text={os} />
                      </div>
                    );
                  })}
                </div>
                <TidalInputField
                  label="License Key"
                  isRequired={true}
                  value={licenseKey}
                  name="licenseKey"
                  onChange={(e: any) => {
                    formik.handleChange(e);
                    setLicenseKey(e.target.value);
                  }}
                  placeholder="XXXXX-XXXXX-XXXXX-XXXXX"
                />
                <p className="tidal-error">{formik.errors.licenseKey}</p>
              </div>
            </TidalDashboardAddNewBotKeySelectedBot>
            <TidalDashboardAddBoyKeyForm>
              <div>
                <TidalDropdown
                  label="License Type"
                  isRequired={true}
                  items={Array.from(
                    new Set(
                      selectedBot.license_types.map((type) =>
                        type.toLowerCase().includes('lifetime')
                          ? 'Lifetime'
                          : 'Renewal',
                      ),
                    ).values(),
                  )}
                  defaultValue={
                    Array.from(
                      new Set(
                        selectedBot.license_types.map((type) =>
                          type.toLowerCase().includes('lifetime')
                            ? 'Lifetime'
                            : 'Renewal',
                        ),
                      ).values(),
                    )[0]
                  }
                  onSelect={(e) => {
                    setLicenseType(e);
                  }}
                />
                {licenseType.toLowerCase() != 'lifetime' && <Box height={16} />}
                {licenseType.toLowerCase() != 'lifetime' && (
                  <TidalDateField
                    sel={renewalDate}
                    setSel={(e) => {
                      setRenewalDate(e);
                    }}
                    label="Renewal Date"
                    isRequired={true}
                  />
                )}

                {licenseType.toLowerCase() != 'lifetime' && <Box height={16} />}
                {licenseType.toLowerCase() != 'lifetime' && (
                  <TidalInputField
                    label="Renewal Days"
                    isRequired={false}
                    type="number"
                    value={renewalInterval}
                    onChange={(e: any) => {
                      formik.handleChange(e);
                      setRenewalInterval(e.target.value);
                    }}
                    placeholder="Enter renewal Days"
                  />
                  // <TidalDropdown
                  //   label="Renewal Interval"
                  //   isRequired={true}
                  //   defaultValue={'0'}
                  //   items={selectedBot.license_types.map((_, i) =>
                  //     i.toString(),
                  //   )}
                  //   onSelect={(e) => {
                  //     setRenewalInterval(e);
                  //   }}
                  // />
                )}
                <Box height={16} />
                <TidalDashboardAddBotKeyModalSubTitle>
                  Tags
                </TidalDashboardAddBotKeyModalSubTitle>
                <Box height={12} />
                <TidalDashboardAddBotKeyTagsRow>
                  {tags.map((tag, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        handleTagSelection(tag);
                      }}
                    >
                      <TidalTag
                        title={tag.title}
                        type={tag.type}
                        enabled={tag.isSelected}
                      />
                    </div>
                  ))}
                </TidalDashboardAddBotKeyTagsRow>
              </div>
              <div>
                <TidalSuffixInputField
                  label="Purchase Price"
                  value={purchasePrice}
                  isRequired={true}
                  name="purchasePrice"
                  onBlur={(e) => formik.handleBlur(e)}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setPurchasePrice(e.target.value);
                  }}
                  type="number"
                  suffix="$"
                  placeholder="0"
                />
                <p className="tidal-error">{formik.errors.purchasePrice}</p>
                {licenseType.toLowerCase() != 'Lifetime' && <Box height={16} />}
                {licenseType.toLowerCase() != 'Lifetime' && (
                  <TidalSuffixInputField
                    label="Renewal Price"
                    suffix="$"
                    value={renewalPrice}
                    onBlur={(e) => formik.handleBlur(e)}
                    type="number"
                    onChange={(e) => setRenewalPrice(e.target.value)}
                    placeholder="0"
                  />
                )}
                <Box height={16} />
                <TidalTextBox
                  label="Notes"
                  placeholder="Enter notes"
                  value={notes}
                  onChange={(e) => {
                    setNotes(e.target.value);
                  }}
                  height={156}
                />
              </div>
            </TidalDashboardAddBoyKeyForm>
            <TidalDashboardAddNewBotKeyModalFooter>
              <TidalButton
                text="Cancel"
                type="default"
                tint={true}
                onClick={onClose}
              />
              <TidalButton
                text="Add Bot Key"
                type="info"
                tint={false}
                disabled={
                  formik.errors.licenseKey != '' ||
                  formik.errors.purchasePrice != ''
                }
                isLoading={isCreating}
                onClick={handleCreateLicenseKey}
              />
            </TidalDashboardAddNewBotKeyModalFooter>
          </div>
        )}
      </TidalDashboardAddBotKeyBodyRow>
    </TidalDashboardAddBotKeyModalWrapper>
  );
};

export default TidalDashboardAddBotKeyModal;
